/* global BigInt */
import { PublicKey } from '@solana/web3.js';
import { getAssociatedTokenAddress, createAssociatedTokenAccountInstruction, createTransferCheckedInstruction,
    createTransferCheckedWithTransferHookInstruction, createTransferCheckedWithFeeAndTransferHookInstruction,
    getTransferFeeConfig, calculateEpochFee, TOKEN_2022_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID } from '@solana/spl-token';

// Reuse the already-loaded mint, account, and decimals for both transfers.
export async function tokenPaymentInstructions({ connection, payer, recipient, mint, senderAta, tokenProgramId, mintInfo, decimals, quote }) {
    const instructions = [];
    const destinations = [{ wallet: recipient, amount: BigInt(quote.baseAmountAtomic) }];
    if (BigInt(quote.paymentFeeAtomic) > 0n) destinations.push({ wallet: new PublicKey(quote.treasuryWallet), amount: BigInt(quote.paymentFeeAtomic) });
    const is2022 = tokenProgramId.equals(TOKEN_2022_PROGRAM_ID);
    const feeConfig = is2022 && mintInfo?.tlvData ? getTransferFeeConfig(mintInfo) : null;
    const epoch = feeConfig ? BigInt((await connection.getEpochInfo('confirmed')).epoch) : null;
    const accounts = new Set();
    for (const destination of destinations) {
        const ata = await getAssociatedTokenAddress(mint, destination.wallet, true, tokenProgramId, ASSOCIATED_TOKEN_PROGRAM_ID);
        if (!accounts.has(ata.toBase58())) {
            accounts.add(ata.toBase58());
            if (!await connection.getAccountInfo(ata)) instructions.push(createAssociatedTokenAccountInstruction(payer, ata, destination.wallet, mint, tokenProgramId, ASSOCIATED_TOKEN_PROGRAM_ID));
        }
        if (feeConfig) {
            const withheld = calculateEpochFee(feeConfig, epoch, destination.amount);
            instructions.push(await createTransferCheckedWithFeeAndTransferHookInstruction(connection, senderAta, mint, ata, payer, destination.amount, decimals, withheld, [], 'confirmed', tokenProgramId));
        } else if (is2022) {
            instructions.push(await createTransferCheckedWithTransferHookInstruction(connection, senderAta, mint, ata, payer, destination.amount, decimals, [], 'confirmed', tokenProgramId));
        } else {
            instructions.push(createTransferCheckedInstruction(senderAta, mint, ata, payer, destination.amount, decimals, [], tokenProgramId));
        }
    }
    return instructions;
}
